export default {
  // status codes
  STATUS_OK: 200,
  STATUS_UNAUTHORIZED: 401,
  STATUS_UNPROCESSABLE_ENTITY: 422,
  STATUS_UNACCEPTABLE: 406,
  STATUS_BAD_REQUEST: 400,
  STATUS_NOT_FOUND: 404,
  STATUS_INTERNAL_SERVER_ERROR: 500,
  STATUS_CREATED: 201,
  STATUS_LIMIT_EXCEEDED: 429,

  //pagination
  DEFAULT_PAGE_SIZE: 10,

  ROLE_HIERARCHY: {
    SUPER_ADMIN: 1,
    ADMIN: 2,
    ASSISTANT: 3,
    ENUMERATOR: 4,
    USER: 5,
  },
  ROLES: ["Super Admin", "Admin", "Assistant", "Enumerator", "User"],
  PROFILEIMAGE_MAX_SIZE: 5 * 1024 * 1024, // 5 MB

  DOC_AND_IMG_UPLOAD_MAX_SIZE: 5 * 1024 * 1024, // 5 MB
  VIDEO_UPLOAD_MAX_SIZE: 15 * 1024 * 1024, // 15 MB

  // Validation error codes
  VALIDATION_TYPES: {
    REQUIRED: "required",
    EMAIL: "email",
    MIN_LENGTH: "minLength",
    MAX_LENGTH: "maxLength",
    PATTERN: "pattern",
    MATCH: "match",
    MIN: "min",
    MAX: "max",
    INVALID_NUMBER: "invalidNumber",
    CONTAINS_UPPERCASE: "containsUppercase",
    CONTAINS_LOWERCASE: "containsLowercase",
    CONTAINS_NUMBER: "containsNumber",
    CONTAINS_SPECIAL: "containsSpecial",
    PHONE: "phone",
    INT: "int",
    EXACT_SELECTIONS: "exactSelections",
    MIN_SELECTIONS: "minSelections",
    MAX_SELECTIONS: "maxSelections",
    MIN_DATE: "minDate",
    MAX_DATE: "maxDate",
    EQUAL_DATE: "equalDate",
    MIN_TIME: "minTime",
    MAX_TIME: "maxTime",
    EQUAL_TIME: "equalTime",
    LINE: "line",
    AREA_MIN: "areaMin",
    AREA_MAX: "areaMax",
    DIFFERENT_FROM_CURRENT: "differentFromCurrent",
    MAX_DECIMAL_PLACES: "maxDecimalPlaces",

    // General regex validations
    REGEX: {
      UPPERCASE: "regex.uppercase", // entire field must be uppercase
      LOWERCASE: "regex.lowercase", // entire field must be lowercase
      NUMERIC: "regex.numeric", // must be numeric only
      ALPHANUMERIC: "regex.alphanumeric", // must be alphanumeric only
    } as const,
  } as const,
  INJECTION_KEYS: {
    respondent: Symbol() as InjectionKey<
      Ref<{ firstName: string; lastName: string }>
    >,
    pendingUploadsCount: Symbol() as InjectionKey<Ref<number>>,
  },

  SW_EVENTS: {
    ONLINE: "ONLINE",
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
    UPLOAD_ERROR: "uploadError",
  },
  APP_EVENTS: {
    LOCATION_PERMISSION_UPDATED: "location:permission-updated",
  },
  IDBVERSION: 3,
  IDBNAME: "relief-insights-db",

  SUBSCRIPTION_STATUS: {
    FREE: "free",
    PENDING: "pending",
    ACTIVE: "active",
    CANCELLED: "cancelled",
    CANCEL_AT_PERIOD_END: "cancel_at_period_end",
    OVER_DUE: "overdue",
    EXPIRED: "expired",
  } as const,
  SUBSCRIPTION_CANCEL_REASONS: {
    USER_REQUEST: "user_request",
    PAYMENT_FAILURE: "payment_failure",
    OTHER: "other",
  } as const,

  DEFAULT_MAX_FIELD_LIMITS: {
    SHORT_TEXT: 255,
    LONG_TEXT: 5000,
    EMAIL: 254,
    PHONE_NUMBER: 20,
    NUMBER: 999_999_999_999,
    DECIMAL: 999_999_999_9,
    DECIMAL_PLACES: 6,
  },
};
